var _path, _path2, _path3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocioEconomics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 50,
    viewBox: "0 0 53 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2513 14.907C8.26077 19.0257 6.73202 27.2045 10.8368 33.1747L21.6836 25.7171L32.5305 18.2595C28.4258 12.2893 20.2419 10.7883 14.2513 14.907Z",
    fill: "#FDE2E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2394 39.6159C23.5837 44.8795 13.1105 42.9402 7.84693 35.2845L21.7089 25.7539L35.5708 16.2234C40.8344 23.8791 38.8952 34.3523 31.2394 39.6159Z",
    fill: "#F3DDDC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3845 21.1427L21.0161 25.3751C24.8392 19.3564 34.3187 8.1488 34.3187 8.1488C38.3523 11.2482 41.3195 15.7655 42.3845 21.1427Z",
    fill: "#F3C0BD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.6974,
    cy: 25.8161,
    r: 7.08436,
    transform: "rotate(55.4902 21.6974 25.8161)",
    fill: "#F3A1A0",
    stroke: "#F3A1A0",
    strokeWidth: 6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocioEconomics);
export default __webpack_public_path__ + "static/media/Socio-economics.062fa4d6ac076b7f712db72fae56ac26.svg";
export { ForwardRef as ReactComponent };